export default {"src":"/_next/static/media/wk-sdf-logo.ba021a28.svg","height":40,"width":574,"blurWidth":0,"blurHeight":0};